import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import GroupBottomTypeArea from "./GroupBottomTypeArea/GroupBottomTypeArea";
import GroupHeaderSection from "./GroupHeaderSection/GroupHeaderSection";
import ChatsSection from "../../../Pages/Channels/ChatsSection/ChatsSection";
import { FadeLoader } from "react-spinners";
import NoChats from "../../../Components/NoChats/NoChats";
import { postApiCaller } from "../../../Libs/apiCaller";
import { toast } from "react-toastify";
import vecChannel from "../../../Assets/Images/ChannelVector.png";
import { useSelector } from "react-redux";
import { CgSpinner } from "react-icons/cg";

export default function ChatingChannelSection({
  hasMoreMessage,
  settings,
  channelActiveChat,
  isNewChannel,
  setActiveSection,
  setShowProfileView,
  showGroupSection,
  children, // ✅ used to render chat messages or other content
  sendMessage,
  showAddMenu,
  sendFilesInMessage,
  allMessages,
  setAllMessages,
  isMessageLoading,
  setGroupPage,
  scrollfetchingData,
  getSecretKey,
  fetchAllUser,
  onChannelSelect,
  fetchChannels,
  setShowAddMenu,
  chatConversationId,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const bottomRef = useRef(null);
  const chatContainerRef = useRef(null);
  const [prevScrollHeight, setPrevScrollHeight] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isFollowingLoading, setIsFollowingLoading] = useState(false);
  const [isDecryptionLoading, setIsDecryptionLoading] = useState(false);

  useEffect(() => {
    setIsDecryptionLoading(true);
  }, [chatConversationId]);

  useEffect(() => {
    if (chatContainerRef.current) {
      const container = chatContainerRef.current;
      const isNearTop = Math.abs(container.scrollTop) < 500; // Consider "near top" as within 100px

      if (isNearTop) {
        container.scrollTop = 0;
      }
    }
  }, [allMessages?.length]);

  useEffect(() => {
    setLoading(false);
    setIsFollowingLoading(false);
  }, [channelActiveChat]);

  useEffect(() => {
    const container = chatContainerRef.current;

    const handleScroll = async () => {
      if (!container || loading || !hasMoreMessage) return;
      const isAtBottom =
        Math.abs(
          container.scrollTop + container.scrollHeight - container.clientHeight
        ) < 1;
      if (isAtBottom) {
        setLoading(true);
        // const prevScrollHeight = container.scrollHeight;
        // setPrevScrollHeight(prevScrollHeight);
        await scrollfetchingData();
        setLoading(false);
      }
    };

    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [loading, scrollfetchingData]);

  const isFollowing = useMemo(() => {
    if (!channelActiveChat) return [];
    return channelActiveChat.users.some(
      (ele) => ele._id == localStorage.getItem("userId")
    );
  }, [channelActiveChat]);

  const followChannel = async () => {
    setIsFollowingLoading(true);
    const endPoint = `channel/subscribe/${channelActiveChat._id}`;
    const response = await postApiCaller(endPoint, {});
    if (response?.status === 200) {
      fetchChannels(true);
      const channel = { ...channelActiveChat };
      channel.users = [userInfo, ...channel.users];
      onChannelSelect(channel);
      toast.success("Channel followed successfully");
    } else {
      toast.error(response?.response?.data?.message || response?.message);
    }
    setIsFollowingLoading(false);
  };

  const bgColor = useMemo(() => {
    return isNewChannel ? "bg-dunes" : `bg-[${settings?.background}]`;
  }, [settings, isNewChannel]);
  return (
    <div className="flex flex-col flex-1 h-full">
      {channelActiveChat && (
        <GroupHeaderSection
          totalUsers={channelActiveChat?.users.length}
          channelActiveChat={channelActiveChat}
          setShowProfileView={setShowProfileView}
          setActiveSection={setActiveSection}
        />
      )}

      {isFollowing ? (
        <main
          className={`flex-1 ${showAddMenu ? "overflow-hidden" : "overflow-y-auto"
            } flex flex-col-reverse pb-0 ${bgColor} dark:bg-slate-900 ${allMessages?.length > 0 ? "pl-4 pb-4" : "px-0"
            }`}
          ref={chatContainerRef}
        >
          {!isMessageLoading && (
            <ChatsSection
              settings={settings}
              allMessages={allMessages}
              setAllMessages={setAllMessages}
              scrollfetchingData={scrollfetchingData}
              getSecretKey={getSecretKey}
              chatConversationId={channelActiveChat}
              isDecryptionLoading={isDecryptionLoading}
              setIsDecryptionLoading={setIsDecryptionLoading}
            />
          )}
          {!isMessageLoading && allMessages?.length === 0 && <NoChats />}
          {/* <div ref={bottomRef}></div> */}
          {loading && (
            <div className="text-center text-sm text-gray-400 py-2">
              Loading messages...
            </div>
          )}
        </main>
      ) : (
        <div className="p-4">
          <div className="mb-6">
            {/* Image Placeholder */}
            <div className="flex mx-auto justify-center mb-8">
              <img src={vecChannel} alt={vecChannel} />
            </div>

            {/* Explanation Section */}
            <h2 className="text-xl text-center font-semibold mb-2">
              What is a channel?
            </h2>
            <p className="text-center text-gray-600 mb-6">
              Channels are a one-to-many tool for broadcasting your messages to
              unlimited audiences.
            </p>
          </div>

          {/* Create Channel Form */}
          <div>
            <button
              onClick={followChannel} // ✅ Toggle here
              disabled={isFollowingLoading}
              className="max-w-2xl btn btn-default bg-[var(--primary-color)] text-white w-full h-12 font-normal rounded-full border-0 flex justify-center mx-auto"
            >
              {isFollowingLoading ? (
                <div className="my-1 mx-5">
                  <CgSpinner className="animate-spin" />
                </div>
              ) : (
                "Follow"
              )}
            </button>
          </div>
        </div>
      )}

      {!isNewChannel &&
        channelActiveChat?.adminId &&
        channelActiveChat?.adminId?.some(
          (admin) => admin._id === localStorage.getItem("userId")
        ) && (
          <footer className="w-full min-h-[80px] bg-white dark:bg-slate-900 flex items-center justify-between border-b border-[#EBEBEB] dark:border-slate-700 text-black dark:text-white p-4 text-center">
            <GroupBottomTypeArea
              onScheduleClick={() => {
                setActiveSection("schedule");
                setShowProfileView(true);
              }}
              showAddMenu={showAddMenu}
              setShowAddMenu={setShowAddMenu}
              sendMessage={sendMessage}
              sendFilesInMessage={sendFilesInMessage}
              channelActiveChat={channelActiveChat}
            />
          </footer>
        )}
    </div>
  );
}
